import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id E345145F-AD51-4B6F-8F7B-EC22C34E4E89
 * name arrow-down-thick
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-thick.svg
 * tags
 * - Arrow 
 */
export const ArrowDownThickIcon = createSvgIcon(<><path d="M10,4H14V13L17.5,9.5L19.92,11.92L12,19.84L4.08,11.92L6.5,9.5L10,13V4Z" /></>, 'ArrowDownThickIcon');
export default ArrowDownThickIcon